import { CodTipoFichaFUR } from '../general/variables';

export class DocumentoDet {
    ndocumentoId: number;
    ndocumentoIdtipd: number;
    cdocumentoCodtipo: string = CodTipoFichaFUR;
    cdocumentoCodsubtipo: string = CodTipoFichaFUR;
    cdocumentoDscurl: string;
    cdocumentoDscnombre: string;
    cdocumentoAsunto: string;

    ddocumentoFchreg: Date;
    strDdocumentoFchreg: string;
    strDdocumentoFchregAMPM: string;
    strDscRutaLocal: string;
    fileBase64: string;

    ndocumentoIdtipodest: number;
    ddocumentoFchemision: Date;
    ndocumentoIdmednotif: number;
    ddocumentoFchnotif: Date;
    ndocumentoIdseguimiento: number;

    strDdocumentoFchemision: string;
    strDdocumentoFchnotif: string;

    // strFchemision:string;
    // strFchnotif:string;
    ndocumentoIdbase: number;
    ddocumentoFchrecep: Date;

    strDdocumentoFchrecep: string;
    // strFchrecep:string;

    listaCargo: DocumentoDet[];
    ndocumentoIdtipdoc: number;
    cdocumentoIdinstan: string;
    byteFile: string|any;
    boolFlgUpLS = false;
    ndocumentoIdestado: number;

}
